import React from 'react';
import * as Text from 'theme/components/Text.style';
import { Arrow } from 'icons/untitledui';
import { Stack, Divider } from '@mui/material';
import ConditionalWrapper from 'layout/components/ConditionalWrapper';
import colours from 'theme/atoms/colours';
import { LoadingStatus } from 'eCoach/hooks/useEcoachItemsConsumer';
import * as Styled from './_styles/ConvoPrep.style';
import LoadingAwareWrapper from './loaders/LoadingAwareItem';

interface Item {
  id: string;
  title: string;
  [key: string]: any;
}

interface SelectedItem {
  status: LoadingStatus;
  data?: Item;
}

interface ClickableListCardProps {
  initialText?: string;
  isNumbered?: boolean;
  ItemDetailsComponent: React.ComponentType<{ item: Item }>;
  items: Item[];
  ListItemComponent: React.ComponentType<{ item: Item }>;
  listTitle?: string;
  selectedItem: SelectedItem;
  selectItem: (id: string | null) => void;
}

export default function ClickableListCard({
  initialText,
  isNumbered,
  ItemDetailsComponent,
  items,
  ListItemComponent,
  listTitle,
  selectedItem,
  selectItem,
}: ClickableListCardProps): JSX.Element {
  if (selectedItem.status !== LoadingStatus.LOADED) {
    return (
      <div
        style={{
          border: `1px solid ${colours.neutral[300]}`,
          borderRadius: '10px',
          padding: '10px 20px',
        }}
      >
        <Text.Label>{listTitle || ''}</Text.Label>
        {initialText && <Text.P2>{initialText}</Text.P2>}
        <Stack divider={<Divider flexItem />}>
          {items.map((item, index) => (
            <Styled.ActionItem key={item.id}>
              <LoadingAwareWrapper
                itemId={item.id}
                loadingId={selectedItem.data?.id}
                handleClick={() => selectItem(item.id)}
              >
                <ConditionalWrapper
                  condition={isNumbered}
                  wrapper={(children) => (
                    <Styled.NumberedContent>{children}</Styled.NumberedContent>
                  )}
                >
                  {isNumbered && (
                    <Styled.NumberBox>
                      <Styled.Number>{index + 1}</Styled.Number>
                    </Styled.NumberBox>
                  )}
                  <Styled.Content>
                    <ListItemComponent item={item} />
                  </Styled.Content>
                </ConditionalWrapper>
              </LoadingAwareWrapper>
            </Styled.ActionItem>
          ))}
        </Stack>
      </div>
    );
  }

  return (
    <div
      style={{
        border: `1px solid ${colours.neutral[300]}`,
        borderRadius: '10px',
        padding: '20px',
      }}
    >
      <Styled.Header onClick={() => selectItem(null)}>
        <Arrow.ChevronLeft />
        <Text.H5>{selectedItem.data.title}</Text.H5>
      </Styled.Header>
      <ItemDetailsComponent item={selectedItem.data} />
    </div>
  );
}
